export interface Theme {
    name: string;
    properties: any;

}
export const light: Theme = {
    name: "light",
    properties: {
  
  
      "--background-color": "#e0dede",
 
  
   
    }
  };
  
  export const dark: Theme = {
    name: "dark",
    properties: {
        "--background-color": "#fff",
    }
  };
